/**
 * This is currently using native fetch rather than @adc/fetch due to the fact that adglare server doesn't like the x-cid header being attached and @adc/fetch
 * automatically attaches the header. Additionally, even if you send the removeHeader symbol in it's place, that symbol has already been replaced with a generated uuid before it gets to the place
 * where the header would be removed because it was send with a removeHeader symbol. If we want to update this to use internal fetch in the future, that will be the one
 * change that will be needed from the fetch side to allow this call to work.
 * @returns the adglare fetch promise
 */

export const fetchAdglareContent = url => {
  const encodedCurrentUrl = encodeURIComponent(
    url || window?.location?.href || ''
  )
  const apiUrl = `https://engine.auction.com/?756106018&referer=${encodedCurrentUrl}`
  return fetch(apiUrl)
}
